import { css, setProps, styled } from "theme";

interface SFetchedFilterSelectClearProps {
  isArabic: boolean;
}

const isArabicLang = setProps<SFetchedFilterSelectClearProps>(({ isArabic }) => isArabic)(css`
  left: 4px;
`);

const isNotArabicLang = setProps<SFetchedFilterSelectClearProps>(({ isArabic }) => !isArabic)(css`
  right: 4px;
`);

export const SFetchedFilterSelectClear = styled.button<SFetchedFilterSelectClearProps>`
  position: absolute;
  top: 50%;
  width: 20px;
  height: 20px;
  transform: translateY(-50%);
  ${isNotArabicLang};
  ${isArabicLang};
`;
